import { render } from "./qcm.vue?vue&type=template&id=3b0827b4&scoped=true"
import script from "./qcm.vue?vue&type=script&lang=js"
export * from "./qcm.vue?vue&type=script&lang=js"

import "./qcm.vue?vue&type=style&index=0&id=3b0827b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0827b4"]])

export default __exports__